// 手机打车——百度地图，主流程
const bdMainRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `car/bd/index${i + 1}`,
  name: `carBdIndex${i + 1}`,
  component: () => import(`@/views/traffic/car/bd/index${i + 1}.vue`),
}));
// 手机打车——百度地图，分支1
const bdBranch1Routes = Array.from({ length: 4 }, (_, i) => ({
  path: `car/bd/branch1/index${i + 1}`,
  name: `carBdBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/traffic/car/bd/branch1/index${i + 1}.vue`),
}));
// 手机打车——百度地图，分支2
const bdBranch2Routes = Array.from({ length: 5 }, (_, i) => ({
  path: `car/bd/branch2/index${i + 1}`,
  name: `carBdBranch2Index${i + 1}`,
  component: () =>
    import(`@/views/traffic/car/bd/branch2/index${i + 1}.vue`),
}));

// 手机打车——高德地图，主流程
const gdMainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `car/gd/index${i + 1}`,
  name: `carGdIndex${i + 1}`,
  component: () => import(`@/views/traffic/car/gd/index${i + 1}.vue`),
}));
// 手机打车——高德地图，分支1
const gdBranch1Routes = Array.from({ length: 7 }, (_, i) => ({
  path: `car/gd/branch1/index${i + 1}`,
  name: `carGdBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/traffic/car/gd/branch1/index${i + 1}.vue`),
}));
// 手机打车——高德地图，分支2
const gdBranch2Routes = Array.from({ length: 5 }, (_, i) => ({
  path: `car/gd/branch2/index${i + 1}`,
  name: `carGdBranch2Index${i + 1}`,
  component: () =>
    import(`@/views/traffic/car/gd/branch2/index${i + 1}.vue`),
}));

// 手机打车——微信，主流程
const wxMainRoutes = Array.from({ length: 16 }, (_, i) => ({
  path: `car/wx/index${i + 1}`,
  name: `carWxIndex${i + 1}`,
  component: () => import(`@/views/traffic/car/wx/index${i + 1}.vue`)
}))
// 手机打车——微信，分支1
const wxBranch1Routes = Array.from({ length: 5 }, (_, i) => ({
  path: `car/wx/branch1/index${i + 1}`,
  name: `carWxBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/traffic/car/wx/branch1/index${i + 1}.vue`),
}));
// 手机打车——微信，分支2
const wxBranch2Routes = Array.from({ length: 7 }, (_, i) => ({
  path: `car/wx/branch2/index${i + 1}`,
  name: `carWxBranch2Index${i + 1}`,
  component: () =>
    import(`@/views/traffic/car/wx/branch2/index${i + 1}.vue`),
}));

// 手机打车——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `car/zfb/index${i + 1}`,
  name: `carZfbIndex${i + 1}`,
  component: () => import(`@/views/traffic/car/zfb/index${i + 1}.vue`)
}))
// 手机打车——支付宝，分支1
const zfbBranch1Routes = Array.from({ length: 6 }, (_, i) => ({
  path: `car/zfb/branch1/index${i + 1}`,
  name: `carZfbBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/traffic/car/zfb/branch1/index${i + 1}.vue`),
}));
// 手机打车——支付宝，分支2
const zfbBranch2Routes = Array.from({ length: 5 }, (_, i) => ({
  path: `car/zfb/branch2/index${i + 1}`,
  name: `carZfbBranch2Index${i + 1}`,
  component: () =>
    import(`@/views/traffic/car/zfb/branch2/index${i + 1}.vue`),
}));

export default {
  path: '/traffic',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 手机打车——百度地图，主流程
    ...bdMainRoutes,
    ...bdBranch1Routes,
    ...bdBranch2Routes,

    // 手机打车——高德地图，主流程
    ...gdMainRoutes,
    ...gdBranch1Routes,
    ...gdBranch2Routes,

    // 手机打车——微信，主流程
    ...wxMainRoutes,
    ...wxBranch1Routes,
    ...wxBranch2Routes,

    // 手机打车——支付宝，主流程
    ...zfbMainRoutes,
    ...zfbBranch1Routes,
    ...zfbBranch2Routes,
    
  ]
}
